import axios from '../../../HttpRequests/axios';

export const FETCH_ESTIMATE_BREAKDOWN_REQUEST = 'FETCH_ESTIMATE_BREAKDOWN_REQUEST';
export const FETCH_ESTIMATE_BREAKDOWN_SUCCESS = 'FETCH_ESTIMATE_BREAKDOWN_SUCCESS';
export const FETCH_ESTIMATE_BREAKDOWN_FAILURE = 'FETCH_ESTIMATE_BREAKDOWN_FAILURE';

export default function fetchEstimateBreakdown() {
  return (dispatch) => {
    dispatch({ type: FETCH_ESTIMATE_BREAKDOWN_REQUEST });

    return axios
      .get('/dashboard/estimates/breakdown')
      .then((response) => {
        dispatch({
          type: FETCH_ESTIMATE_BREAKDOWN_SUCCESS,
          payload: response.data.data,
        });
        return response.data.data;
      })
      .catch((error) => {
        console.error('Estimate Breakdown Error:', error);
        dispatch({
          type: FETCH_ESTIMATE_BREAKDOWN_FAILURE,
          payload: error.message || 'Failed to load estimate breakdown',
        });
        throw error;
      });
  };
}
